import SystemNotificationList from './SystemNotificationList';

export * from './types';

export default SystemNotificationList;
